<div
  class="flex flex-col items-center justify-center rounded-2xl bg-white p-10 shadow-sm animate-pulse"
>
  <div class="h-8 w-32 bg-slate-200 rounded mb-4"></div>
  <p class="text-slate-500">Setting things up...</p>
</div>
